import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { useOnboardingStore } from '../store/onboardingStore'
import { Button } from '../components/Button'
import { V2Icon } from '../components/v2'
import { usesAppLook } from '../lib/variant'

export function SolutionStep() {
  const { goNext } = useOnboardingStore()
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setShowButton(true), 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="min-h-dvh flex flex-col bg-gradient-to-b from-teal-600 to-teal-800">
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="w-full max-w-md text-center"
        >
          {usesAppLook() ? (
            <V2Icon name="mascot-heart" size={96} className="block mx-auto mb-6" />
          ) : (
            <div className="text-6xl mb-6">💚</div>
          )}

          <h1 className="text-3xl font-bold text-white mb-4">
            We hear you.
          </h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="text-teal-100 text-lg mb-4"
          >
            You deserve a simple way to know exactly what's safe to eat for your kidneys.
          </motion.p>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.0 }}
            className="text-teal-100 text-lg mb-10"
          >
            KidneyPal uses AI to instantly analyze any meal and tell you if it's kidney-safe - personalized to your exact condition.
          </motion.p>

          {showButton && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <Button onClick={() => goNext()} variant="white">
                Show me how
              </Button>
            </motion.div>
          )}
        </motion.div>
      </div>
    </div>
  )
}
